module.exports = __webpack_public_path__ + "ebf6ece3658e5b037f2a06dbb7ce0173.svg";